export const ID_ELEMENT_RELEASE_SCHEDULE = 'releaseSchedule';

export const ROOT_ELEMENT = document.getElementById('root') as HTMLDivElement;